export const HttpIndicator = () => {
	return null
}
